app.service('simpleToastr', function ($global, console) {

	function open(id, timer) {
		if (isExist(id)) {
			console.log('otwieramy warstwę: ' + id);
			let $simpleToastr = $('[data-simple-toastr-id=' + id + ']');
			$simpleToastr.addClass('toastr-is-open');
			setAutoClose(id, timer);
			return $simpleToastr;
		} else {
			console.log('NIE ISTNIEJE SIMPLE TOASTR: ' + id);
		}
	}
	function isOpen(id) {
		if (isExist(id)) {
			return $('[data-simple-toastr-id=' + id + ']').hasClass('toastr-is-open');
		}
		return false;
	}
	function isExist(id) {
		return $('[data-simple-toastr-id=' + id + ']').length ? true : false;
	}
	function setAutoClose(id, timer) {
		setTimeout(function () {
			if (isOpen(id)) {
				close(id);
			}
		}, (timer && timer > 1) ? timer * 1000 : 5000);
	}
	function close(id) {
		let $toastr = $('[data-simple-toastr-id=' + id + ']');
		$toastr.addClass('toastr-is-closing');
		setTimeout(function () {
			if (isOpen(id)) {
				$toastr.removeClass('toastr-is-open toastr-is-closing');
			}
		}, 600);
	}

	function setEvents() {
		$('body').on('click', '.js-simple-toastr-close', function () {
			close($(this).parent().data('simple-toastr-id'));
		});
	}
	function init() {
		setEvents();
	}
	function generate(content) {
		confirm(content);
	}
	$global('openSimpleToarst', open);
	return {
		init,
		generate,
		open,
		isOpen
	};
});
